export default "__VITE_ASSET__5p8xAv93__"